<template>
  <div class="wrapper">
    <div class='vertex' v-if="title">
      <div class='icon-wrapper' @click="toggleShow">
        <span :class="['icon mdi mdi-triangle', (show ? 'mdi-rotate-180' : 'mdi-rotate-90')]" v-if="!isLeaf"></span>
      </div>
      <b-checkbox class="checkbox" v-model="isSelected" @change.native="toggleStatus" :indeterminate="indeterminate"></b-checkbox>
      <span :class="{'clickable': !isLeaf}" @click="toggleShow">{{title}}</span>
    </div>
    <div v-for="(child, idx) in children" :key="idx">
      <SelectTree ref='child_tree' :class="{'hidden': (!show && title), 'child': title}"
      :contents="child.contents" :statusKey="statusKey" :displayKey="displayKey" :title="child.title" @setParentStatus="autoSetStatus"></SelectTree>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SelectTree',
  props: {
    contents: {
      type: Object,
      required: true,
    },
    statusKey: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
    },
    displayKey: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      show: false,
      isSelected: true,
      indeterminate: false
    }
  },
  mounted () {
    if (this.contents[this.statusKey] == undefined) {
      this.isSelected = true
      this.indeterminate = true
    } else {
      this.isSelected = this.contents[this.statusKey]
      this.indeterminate = false
    }
  },
  watch: {
    contents: {
      handler: function () {
        if (this.contents[this.statusKey] == undefined) {
          this.isSelected = true
          this.indeterminate = true
        } else {
          this.isSelected = this.contents[this.statusKey]
          this.indeterminate = false
        }
      },
      deep: true
    }
  },
  computed : {
    children () {
      const keys = Object.keys(this.contents).filter((key) => key!=this.statusKey && key!=this.displayKey)
      return keys.map(
        (key) => {
          return {title: (this.contents[key][this.displayKey] || key), contents: this.contents[key]}
        }
      )
    },
    isLeaf () {
      return this.children.length == 0
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    toggleStatus () {
      this.propagateStatus(this.isSelected)
      this.$emit('setParentStatus')
    },
    propagateStatus (bool) {
      //親の選択状態を伝播
      this.isSelected = bool
      this.indeterminate = false
      this.contents[this.statusKey] = bool
      if (this.isLeaf) return
      for (let child of this.$refs.child_tree) {
        child.propagateStatus(this.contents[this.statusKey])
      }
    },
    autoSetStatus () {
      //子の選択状態が変化した際に親の状態を自動変更
      if (this.children.every((child) => child.contents[this.statusKey] == true)) {
        this.isSelected = true
        this.indeterminate = false
        this.contents[this.statusKey] = true
      }
      else if (this.children.every((child) => child.contents[this.statusKey] == false)) {
        this.isSelected = false
        this.indeterminate = false
        this.contents[this.statusKey] = false
      }
      else {
        this.isSelected = true
        this.indeterminate = true
        this.contents[this.statusKey] = undefined
      }
      this.$emit('setParentStatus')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  white-space: nowrap;
  overflow-x: hidden;
  .vertex {
    display: flex;
    .checkbox {
      margin-right: 0;
    }
    .icon-wrapper {
      min-width: 24px;
      min-height: 24px;
      position: relative;
      cursor: pointer;
      .icon {
        position: relative;
        top: -2px;
      }
    }
    .clickable {
      cursor: pointer;
    }
  }
  .child {
    margin-left: 16px;
  }
  .hidden {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Operation/SelectTree.vue